// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9574d2aa","627":"86930594","732":"6bb5cdc9","977":"eab9a857"}[chunkId] + ".chunk.js";
};